export default __webpack_public_path__ + "static/media/bussiness.2823c0ce.svg";